import { render, staticRenderFns } from "./MomentumDashboard.vue?vue&type=template&id=129bd6b7&"
import script from "./MomentumDashboard.vue?vue&type=script&lang=js&"
export * from "./MomentumDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports